import { DataEndChannelTypeEnum } from "../enums/data-end-channel-type.enum";

export enum CameraTypeEnum {
        Unknown = 0,
        LicensePlate = 1,
        PTZ = 2
}

export function getCameraName(cameraType: CameraTypeEnum): string {
    switch (cameraType) {
         case CameraTypeEnum.Unknown:
            return 'Kamera';
        case CameraTypeEnum.LicensePlate:
            return 'Kennzeichenkamera'
        case CameraTypeEnum.PTZ:
            return 'PTZ Kamera'
    }
}
export function getCameraType(detype: DataEndChannelTypeEnum): CameraTypeEnum {
    switch (detype) {
        case DataEndChannelTypeEnum.LPCam:
            return CameraTypeEnum.LicensePlate;
        case DataEndChannelTypeEnum.DOM_CAMERA:
            return CameraTypeEnum.PTZ
        default:
            return CameraTypeEnum.Unknown;
    }
}
